import React, { useEffect, useState } from 'react';

interface SuccessPageProps {
  onContinue: () => void;
}

const SuccessPage: React.FC<SuccessPageProps> = ({ onContinue }) => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Pequeno delay para a animação de entrada
    setTimeout(() => setShowContent(true), 100);
  }, []);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4 font-sans relative overflow-hidden">
      {/* Background Decorativo */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-4xl">
          <div className="absolute top-1/4 left-1/4 w-72 h-72 bg-emerald-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob"></div>
          <div className="absolute top-1/3 right-1/4 w-72 h-72 bg-teal-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000"></div>
        </div>
      </div>

      <div className={`max-w-lg w-full text-center relative z-10 transition-all duration-1000 transform ${showContent ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
        
        {/* Ícone de Sucesso Animado */}
        <div className="w-28 h-28 bg-emerald-50 rounded-full flex items-center justify-center mx-auto mb-8 relative">
          <div className="absolute inset-0 border-4 border-emerald-100 rounded-full animate-[ping_2s_cubic-bezier(0,0,0.2,1)_infinite]"></div>
          <div className="w-20 h-20 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full flex items-center justify-center shadow-lg shadow-emerald-500/30">
            <svg className="w-10 h-10 text-white animate-[bounce_1s_infinite]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <h1 className="text-4xl font-black text-gray-900 mb-4 tracking-tight">
          Pagamento Aprovado!
        </h1>
        <p className="text-xl text-gray-600 mb-8 leading-relaxed">
          Bem-vindo à elite, <span className="font-bold text-emerald-600">Concurseiro PRO</span>. <br/>
          Seu acesso ilimitado já está liberado.
        </p>

        {/* Card de Resumo do que foi liberado */}
        <div className="bg-white border-2 border-emerald-50 rounded-2xl p-6 mb-8 shadow-sm text-left mx-4">
          <p className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-4 text-center">Agora você tem acesso a:</p>
          <div className="space-y-3">
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 text-emerald-600 font-bold text-xs">✓</div>
              <span className="text-gray-700 font-medium">Banco completo de questões</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 text-emerald-600 font-bold text-xs">✓</div>
              <span className="text-gray-700 font-medium">Professor Pobre (IA) Ilimitado</span>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-6 h-6 rounded-full bg-emerald-100 flex items-center justify-center flex-shrink-0 text-emerald-600 font-bold text-xs">✓</div>
              <span className="text-gray-700 font-medium">Simulados e Estatísticas</span>
            </div>
          </div>
        </div>

        {/* Botão de Ação */}
        <button 
          onClick={onContinue}
          className="w-full bg-gray-900 hover:bg-black text-white font-bold text-lg py-4 rounded-xl shadow-xl transition transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 group"
        >
          Começar a Estudar
          <svg className="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </button>

        <p className="mt-6 text-sm text-gray-400">
          Enviamos o comprovante para o seu e-mail.
        </p>
      </div>
    </div>
  );
};

export default SuccessPage;